export const profile = {
  action: 'updateProfile',
  button: {
    label: 'Update profile',
  },
  fields: {
    first_name: {
      type: 'text',
      label: 'First Name',
      placeholder: 'First name',
      autocomplete: 'first name',
      min: 2,
    },
    last_name: {
      type: 'text',
      label: 'Last Name',
      placeholder: 'Last name',
      autocomplete: 'last name',
      min: 2,
    },
    gender: {
      type: 'select',
      label: 'Gender',
      placeholder: 'Gender',
      options: [
        {
          label: 'Male',
          value: 'M',
        },
        {
          label: 'Female',
          value: 'F',
        },
      ],
      value: 0,
    },
    birthdate: {
      type: 'date',
      label: 'Date of birth',
      autocomplete: 'date of birth',
      min: 18,
    },
    phone: {
      type: 'tel',
      label: 'Phone number',
      autocomplete: 'tel',
    },
    zip: {
      type: 'text',
      label: 'Zip code',
      placeholder: 'Zip code',
      autocomplete: 'zip code',
      min: 2,
    },
    email: {
      type: 'text',
      label: 'Email',
      placeholder: 'email',
      autocomplete: 'email',
      min: 2,
    },
  },
};

export default {
  profile,
};



// WEBPACK FOOTER //
// ./client/models/profile/index.js